import * as React from 'react';
import { SvgIcon as MuiSvgIcon, SvgIconProps, styled } from '@mui/material';

const SvgIcon = styled(MuiSvgIcon, {
    name: 'DocumentUpload',
    shouldForwardProp: (prop) => prop !== 'fill'
})<SvgIconProps>(() => ({
    fill: 'currentColor'
}));

SvgIcon.defaultProps = {
    viewBox: '0 0 24 24',
    focusable: 'false',
    'aria-hidden': 'true'
};

const DocumentUpload: React.FunctionComponent<SvgIconProps> = (props) => {
    return (
        <SvgIcon {...props}>
            <path d="M20.5 10.69H17.61C15.24 10.69 13.31 8.76 13.31 6.39V3.5C13.31 2.95 12.86 2.5 12.31 2.5H8.07C4.99 2.5 2.5 4.5 2.5 8.07V16.93C2.5 20.5 4.99 22.5 8.07 22.5H15.93C19.01 22.5 21.5 20.5 21.5 16.93V11.69C21.5 11.14 21.05 10.69 20.5 10.69ZM11.53 14.03C11.38 14.18 11.19 14.25 11 14.25C10.81 14.25 10.62 14.18 10.47 14.03L9.75 13.31V17.5C9.75 17.91 9.41 18.25 9 18.25C8.59 18.25 8.25 17.91 8.25 17.5V13.31L7.53 14.03C7.24 14.32 6.76 14.32 6.47 14.03C6.18 13.74 6.18 13.26 6.47 12.97L8.47 10.97C8.54 10.91 8.61 10.86 8.69 10.82C8.71 10.81 8.74 10.8 8.76 10.79C8.82 10.77 8.88 10.76 8.95 10.75C8.98 10.75 9 10.75 9.03 10.75C9.11 10.75 9.19 10.77 9.27 10.8C9.28 10.8 9.28 10.8 9.29 10.8C9.37 10.83 9.45 10.89 9.51 10.95C9.52 10.96 9.53 10.96 9.53 10.97L11.53 12.97C11.82 13.26 11.82 13.74 11.53 14.03Z" />
            <path d="M17.4302 9.31048C18.3802 9.32048 19.7002 9.32048 20.8302 9.32048C21.4002 9.32048 21.7002 8.65048 21.3002 8.25048C19.8602 6.80048 17.2802 4.19048 15.8002 2.71048C15.3902 2.30048 14.6802 2.58048 14.6802 3.15048V6.64048C14.6802 8.10048 15.9202 9.31048 17.4302 9.31048Z" />
        </SvgIcon>
    );
};

export default DocumentUpload;
